export default "__VITE_ASSET__D_LpZ7Fh__"